import "@lottiefiles/lottie-player";
import { create } from "@lottiefiles/lottie-interactivity";

window.addEventListener('DOMContentLoaded', (event) => {
  create({
    player: "#stars2",
    mode: "scroll",
    actions: [
      {
        visibility: [0.1, 0.38],
        type: "seek",
        frames: [0, 35]
      }
    ]
  });

  // these doesn't seem to work 🤷🏻‍♂️
  // create({
  //   player: "#stars1",
  //   mode: "scroll",
  //   actions: [
  //     {
  //       visibility: [0.3, 1],
  //       type: "seek",
  //       frames: [0, 60]
  //     }
  //   ]
  // });

  // create({
  //   player: "#shapes",
  //   mode:"scroll",
  //   container: "#inspiration",
  //   actions: [
  //     {
  //       visibility: [0.5, 1],
  //       type: "seek",
  //       frames: [0, 59]
  //     }
  //   ]
  // });
});
